import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector, useAppDispatch } from '../../../../../app/store';
import { updateCheckInfoAction as updateCheckInfo } from '../../../../../services/RefundService/slice';

export const CityField: React.FC = () => {
    const dispatch = useAppDispatch();
    const { currentRefund } = useAppSelector(state => state.refund);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
        dispatch(updateCheckInfo({ city: event.target.value }));
    };

    return (
        <TextField
            label="City"
            value={currentRefund?.checkInfo?.city || ''}
            onChange={handleChange}
            size="small"
            sx={{ flex: 2 }}
        />
    );
};

export default CityField;
